/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_Import_Error_Too_LargeInputs */

const en_zotero_browser_import_error_too_large = /** @type {(inputs: Zotero_Browser_Import_Error_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file is too large to convert to audio.`)
};

const es_zotero_browser_import_error_too_large = /** @type {(inputs: Zotero_Browser_Import_Error_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este archivo es demasiado grande para convertirlo en audio.`)
};

/**
* | output |
* | --- |
* | "This file is too large to convert to audio." |
*
* @param {Zotero_Browser_Import_Error_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_import_error_too_large = /** @type {((inputs?: Zotero_Browser_Import_Error_Too_LargeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Import_Error_Too_LargeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_import_error_too_large(inputs)
	return en_zotero_browser_import_error_too_large(inputs)
});